import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  crumbs: Crumb[];
  eyebrow?: string;
  title: string;
  description?: string;
  meta?: string;
}

export default function PageHeader({ crumbs, eyebrow, title, description, meta }: PageHeaderProps) {
  return (
    <header className="mb-6 md:mb-8">
      <Breadcrumb items={crumbs} />
      <div className="mt-5">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-6 h-[2px] bg-accent-500 inline-block" />
            <span className="font-label tracking-[0.2em] text-xs uppercase text-accent-400">{eyebrow}</span>
          </div>
        )}
        <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-wide text-foreground-950">{title}</h1>
        {description && (
          <p className="mt-3 text-sm md:text-[15px] text-foreground-500 leading-relaxed max-w-3xl">{description}</p>
        )}
        {meta && <p className="mt-2 text-xs font-label tracking-wide text-foreground-600">{meta}</p>}
      </div>
    </header>
  );
}